<template>
  <div>
    <tippy
     v-bind:to="'card-box-menu-'+referral.id"
     placement="bottom-end"
     offset="[10, 2]"
     interactive
     arrow
     trigger="click">
     <div class="morePopMenuBox-content ">

       <router-link
         class="morePopMenuBox-content-item"
         :to="{ name:'teams_client_view', params: { id: referral.slug } }">
         <span class="icon-editor_view"></span>View
       </router-link>

       <router-link
         v-if="referral.pending == 1"
         :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: referral.pending_from == 0 ? referral.id : referral.pending_from } }"
         class="morePopMenuBox-content-item">
         <span class="icon-action_check"></span>Resolve
       </router-link> <!-- RoundCorners -->

       <router-link
         v-show="referral.archive != 1"
         class="morePopMenuBox-content-item"
         :to="{ name:'teams_client_update', params: { id: referral.slug } }">
         <span class="icon-action_edit"></span>Edit
       </router-link>

       <a
        v-if="referral.expiring == 1 && referral.extended_allowed == 1"
        @click="confirm({
          id: referral.id,
          type: 'extend-referral',
          available_extended: referral.available_extended
        })"
        href="javascript:void(0)" class="morePopMenuBox-content-item">
         <span class="icon-action_refresh"></span>Extend
       </a>

       <a
        v-if="$store.getters.forArchive(referral)"
        @click="confirm({
          id: referral.id,
          type: 'archive',
          client: $store.getters.formatFullName(referral.first_name, referral.last_name)
        })"
        href="javascript:void(0)" class="morePopMenuBox-content-item">
         <span class="icon-action_archive"></span>Archive
       </a>




<!--
       <a href="#" class="morePopMenuBox-content-item">
         <span class="icon-action_archive"></span>Archive
       </a> -->
     </div>
   </tippy>

   <div class="dvCardClient">
     <div class="dvCardClient-header">
       <div class="dvCardClient-header-name"><span :class="$store.getters.classReferralBg(referral)" class="flexCenterAll icon-fs_user"></span>{{ $store.getters.formatFullName(referral.first_name, referral.last_name) }}</div>
       <div class="dvCardClient-header-menu">
         <a
           v-if="referral.expiring == 1 && referral.extended_allowed == 1"
           @click="confirm({
             id: referral.id,
             type: 'extend-referral',
             available_extended: referral.available_extended
           })"
           class="waves-effect waves-dark dvCardClient-header-linkRenew flexCenterAll" href="javascript:void(0)"><span class="icon-action_refresh"></span>Extend</a>


         <router-link
           v-if="referral.pending == 1"
           :to="{ name:'team_member_resolve', params: { id: member.id, referral_id: referral.pending_from == 0 ? referral.id : referral.pending_from } }"
           class="waves-effect waves-light btn-Pill isResolve">
           <span class="icon-action_check_circle hide-on-small-only"></span>
           <div class="label">Resolve</div>
         </router-link>

         <a
           :name="'card-box-menu-'+referral.id"
           :ref="'tippy_menu'+referral.id"
           class="waves-effect waves-dark dvCardClient-header-link flexCenterAll"
           href="javascript:void(0)">
           <span class="icon-nav_more_horz"></span>
         </a>

       </div> <!-- dvCardClient-header-menu -->
     </div> <!-- dvCardClient-header -->

     <div class="dvCardClient-content">
       <div class="row">
         <div class="col s12 m6">
           <div class="dvCardClient-content-item"><span class="icon-content_email"></span><a :href="'mailto:'+referral.email">{{ referral.email }}</a></div>
           <div v-show="hasContact(referral)" class="dvCardClient-content-item"><span class="icon-content_mobile"></span><div v-html="displayContactNos(referral)"></div></div>
           <div class="dvCardClient-content-item" v-show="referral.address"><span class="icon-content_location"></span>{{ referral.address }}</div>
         </div> <!-- col -->
         <div class="col s12 m6">
           <div class="dvCardClient-content-item" v-show="referral.project_interested_in"><span class="icon-content_project"></span>{{ referral.project_interested_in }}</div>
           <div class="dvCardClient-content-item"><span class="icon-content_activity"></span>Added: {{ referral.date_submitted | moment("MM/D/YYYY, h:mm A") }}</div>
           <div class="dvCardClient-content-item" :class="$store.getters.classReferralColValid(referral)">
             <span class="icon-content_status" :class="$store.getters.classReferralColValid(referral)"></span>{{ $store.getters.submittedAgo(referral) }}
           </div>
         </div> <!-- col -->

       </div> <!-- row -->
     </div> <!-- dvCardClient-content -->
   </div> <!-- dvCardClient -->

  </div>
</template>

<script>
  export default {
    name: 'referral-card-view',
    props: ['referral', 'idx', 'member'],
    data: () => ({
    }),
    computed: {
    },
    methods: {
      confirm (action){
        let el = this.$refs['tippy_menu'+this.idx];
        if (el && el._tippy) {
            el._tippy.hide()
        }


        this.$emit('confirm', action)


      },
      // doConfirm (){
      //   if(this.action == 'archive'){
      //     this.processArchive(this.actionId)
      //   }
      // },
      updateClient(id){
        this.$router.push({ name:'referrals_update_client', params: { id: id } })
      },
      processArchive (id){
        this.$emit('processArchive', id);
      },
      extendReferral (id){
        this.$emit('extendReferral', id);
      },
      hasContact: function(referral){
        return this.displayContactNos(referral) == '' ? false : true
      },
      displayContactNos: function(referral) {
        let mobTels = [];
        if(referral.mobile_no.length > 0){
          mobTels.push('<a href="tel:'+referral.mobile_no+'">'+referral.mobile_no+'</a>')
        }

        return mobTels.join(', ')
      }
    },
    mounted() {
    },
    components: {
    }
  }
</script>
